module.exports = __webpack_public_path__ + "img/about-img-01.3ab8fa4c.png";